
import React, { useState, Fragment, useRef, useEffect } from "react"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { setOrderIsLate } from "services"
import { Button, ConfirmationModal } from "components"
import classes from "./OrderDetailLateButton.module.scss"

const OrderDetailLateButton = props => {
  const { order, setOrders } = props

  const [t, i18n] = useTranslation()

  const [sending, setSending] = useState(false)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const unmount = useRef(false)

  const handleCompleteOrder = async () => {
    setSending(true)

    try {
      await setOrderIsLate(order._id)

      setOrders(prev =>
        prev.map(o =>
          o._id === order._id
            ?
            {
              ...o,
              isOrderLate: true,
              orderLateAt: new Date(),
              orderDelayInMinutes: 0
            }
            : o
        )
      )

      setShowConfirmationModal(false)
    } catch (err) {
      console.log(err)

      toast.error(t("سفارش_ویرایش_نشد"))

      setSending(false)
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <Button
        fullWidth
        color="danger"
        onClick={() => setShowConfirmationModal(true)}
        className={clsx(
          classes["button"],
          isLtr && classes["button-ltr"]
        )}
      >
        {t("تاخیر_در_سفارش")}
      </Button>

      <ConfirmationModal
        title={t("آیا_می_خواهید_برای_این_سفارش_تاخیر_بزنید")}
        show={showConfirmationModal}
        onConfirm={handleCompleteOrder}
        onHide={() => setShowConfirmationModal(false)}
        loading={sending}
      />
    </Fragment>
  )
}

export default OrderDetailLateButton